import { ISupplierSupplement } from '../../types/entities/ISupplierSupplement';
import { ISupplementDetailState } from '../../types/supplement/supplementsTypes';
import { convertDateToUTC, isMinValueDate } from '../../utils/formatDates';

export const adaptSupplementDetailFromDDBB = (
    data: ISupplierSupplement
): ISupplementDetailState => {
    return {
        Id: data.Id,
        Enabled: data.Enabled,
        Name: data.Name,
        Description: data.Description,
        IdSupplierHotel: data.IdSupplierHotel,
        SupplierHotel: data.SupplierHotel?.Name || '',
        IdSupplierHotelRoomType: data.IdSupplierHotelRoomType,
        SupplierHotelRoomType: data.SupplierHotelRoomType?.Name || '',
        IdSupplierHotelMealPlan: data.IdSupplierHotelMealPlan,
        SupplierHotelMealPlan: data.SupplierHotelMealPlan?.Name || '',
        IdSupplierHotelRatePlan: data.IdSupplierHotelRatePlan,
        SupplierHotelRatePlan: data.SupplierHotelRatePlan?.Name || '',
        FromDate: isMinValueDate(data.FromDate) ? null : data.FromDate,
        ToDate: isMinValueDate(data.ToDate) ? null : data.ToDate,
        IdCurrency: data.IdCurrency,
        Currency: data.Currency?.Name || '',
        Amount: data.Amount,
        EffectivePerson: data.EffectivePerson,
        OnlyAdults: data.OnlyAdults,
        OnlyChildren: data.OnlyChildren,
        Priority: data.Priority,
        IdSupplementCalculationType: data.IdSupplementCalculationType,
        SupplementCalculationType:
            data.SupplementCalculationType?.LocalizedCaption ||
            data.SupplementCalculationType?.Caption ||
            data.SupplementCalculationType?.Name ||
            '',
        IdSupplierTaxCalculationRuleType: data.IdSupplierTaxCalculationRuleType,
        SupplierTaxCalculationRuleType:
            data.SupplierTaxCalculationRuleType?.LocalizedCaption ||
            data.SupplierTaxCalculationRuleType?.Caption ||
            data.SupplierTaxCalculationRuleType?.Name ||
            '',
        SupplierTaxCalculationRuleTypeKey:
            data.SupplierTaxCalculationRuleType?.Key || '',
        IdSupplierTaxCalculationType: data.IdSupplierTaxCalculationType,
        SupplierTaxCalculationType:
            data.SupplierTaxCalculationType?.LocalizedCaption ||
            data.SupplierTaxCalculationType?.Caption ||
            data.SupplierTaxCalculationType?.Name ||
            '',
        SupplierTaxCalculationTypeKey:
            data.SupplierTaxCalculationType?.Key || '',
        FromAge: data.FromAge,
        ToAge: data.ToAge,
    };
};

export const adaptSupplementToDDBB = (
    supplementData: ISupplementDetailState
) => {
    return {
        Id: supplementData.Id,
        Enabled: supplementData.Enabled,
        Name: supplementData.Name,
        Description: supplementData.Description,
        IdSupplierHotel: supplementData.IdSupplierHotel,
        IdSupplierHotelRoomType: supplementData.IdSupplierHotelRoomType,
        IdSupplierHotelMealPlan: supplementData.IdSupplierHotelMealPlan,
        IdSupplierHotelRatePlan: supplementData.IdSupplierHotelRatePlan,
        FromDate: supplementData.FromDate
            ? convertDateToUTC(supplementData.FromDate)
            : null,
        ToDate: supplementData.ToDate
            ? convertDateToUTC(supplementData.ToDate)
            : null,
        IdCurrency: supplementData.IdCurrency,
        Amount: supplementData.Amount,
        EffectivePerson: supplementData.EffectivePerson,
        OnlyAdults: supplementData.OnlyAdults,
        OnlyChildren: supplementData.OnlyChildren,
        Priority: supplementData.Priority,
        IdSupplementCalculationType: supplementData.IdSupplementCalculationType,
        IdSupplierTaxCalculationRuleType:
            supplementData.IdSupplierTaxCalculationRuleType,
        IdSupplierTaxCalculationType:
            supplementData.IdSupplierTaxCalculationType,
        FromAge: supplementData.FromAge,
        ToAge: supplementData.ToAge,
    };
};
